import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import { GeocodeResult } from "@/geoMap/GeocodeResult";
import { withDefaults } from "vue";

interface Props {
  modifires?: typeModifires;
  address?: GeocodeResult;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'address-table-row',
  props: {
    modifires: { type: [String, Array, Boolean] },
    address: {}
  },
  emits: ["moveMap"],
  setup(__props: any, { emit }) {

const props = __props;




/**
 * 地図の指定地点へ移動
 */
const moveMap = () => {
  if (props.address) {
    emit("moveMap", props.address);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(mapModifires)('address-table-row', _ctx.modifires))
  }, [
    _createElementVNode("div", {
      class: "address-table-row__cell",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (moveMap()))
    }, _toDisplayString(_ctx.address ? _ctx.address.address : "該当住所なし"), 1)
  ], 2))
}
}

})